import 'material-design-icons-iconfont/dist/material-design-icons.css' 
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
// import 'vuetify/src/stylus/app.styl'
import 'vuetify/src/styles/main.sass'
import { store } from '../store'


Vue.use(Vuetify)

const opts = {
	icons: {
		iconfont: 'md',
	},
	theme: {
		
		primary: store.state.primary || '#000',
		success: store.state.success || '#3cd1c2',
		info: store.state.info || '#ffaa2c',
		error: '#f83e70'
	}
}

export default new Vuetify(opts)
